import React, { useState } from 'react';
import { moments } from '../mock';
import DesignEscapeModal from './egypt/DesignEscapeModal';
import { destinations } from '../destinationsData';

// Destination options (name + image) for the "Design Your Escape" popup dropdown.
const DEST_OPTIONS = (() => {
  const map = new Map();
  Object.values(destinations).forEach((list) => list.forEach((d) => { if (!map.has(d.name)) map.set(d.name, { name: d.name, image: d.src }); }));
  return [...map.values()].sort((a, b) => a.name.localeCompare(b.name));
})();

export default function Moments() {
  const [planOpen, setPlanOpen] = useState(false);
  return (
    <section id="moments" className="pt-16 md:pt-20 overflow-hidden scroll-mt-24" data-testid="moments-section">
      <div className="tl-container flex flex-col items-center gap-6 text-center">
        <h2 className="t-section text-onsurface">{moments.heading}</h2>
        <div className="flex items-center gap-3" data-testid="moments-subheading">
          <span className="flex -space-x-2">
            {moments.avatars.map((a, i) => (
              <img key={i} src={a} alt="" className="w-7 h-7 rounded-full object-cover ring-2 ring-surface" />
            ))}
          </span>
          <span className="t-body-lg text-onsurface">{moments.subheading}</span>
        </div>
      </div>

      <div className="mt-8 w-full overflow-hidden" data-testid="moments-marquee">
        <div className="moments-track flex w-max pb-1" data-testid="moments-track">
          {[0, 1].map((copy) => (
            <div key={copy} className="flex gap-4 pr-4 shrink-0" aria-hidden={copy === 1} data-testid={`moments-track-set-${copy}`}>
              {moments.items.map((m) => (
                <article key={m.title} className="relative shrink-0 w-[256px] h-[328px] rounded-xl overflow-hidden" data-testid="moment-card">
                  <img src={m.image} alt={m.title} className="absolute inset-0 w-full h-full object-cover object-center" loading="lazy" />
                  <div className="absolute inset-0 bg-gradient-to-t from-[#002131]/80 via-[#002131]/20 to-transparent" />
                  <div className="absolute inset-x-0 bottom-0 p-4 text-white">
                    <h3 className="text-[12px] leading-[16px] font-medium">{m.title}</h3>
                    <p className="text-[12px] leading-[16px] text-white/80 mt-1 font-normal">{m.name}</p>
                  </div>
                </article>
              ))}
            </div>
          ))}
        </div>
      </div>

      <div className="flex justify-center mt-8">
        <button className="btn-filled" data-testid="moments-cta" onClick={() => setPlanOpen(true)}>{moments.cta}</button>
      </div>

      <DesignEscapeModal
        open={planOpen}
        onClose={() => setPlanOpen(false)}
        selectable
        destinationOptions={DEST_OPTIONS}
        image={DEST_OPTIONS[0] && DEST_OPTIONS[0].image}
      />
    </section>
  );
}
